var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideo = function SvgIconVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.8 88.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A070C",
    d: "M0 88.7V0l69.8 44.3zm7-74.5v60.4l47.6-30.2z"
  })));
};
export default SvgIconVideo;